import { X } from "lucide-react"; // You can replace this with any icon library you prefer

const Modal = ({ isOpen, onClose, title, message, type = "info" , children }) => {
  if (!isOpen) return null;

  const colorStyles = {
    success: {
      border: "border-green-500",
      title: "text-green-700",
      message: "text-green-600",
      iconBg: "bg-green-100",
      icon: "✅",
    },
    error: {
      border: "border-red-500",
      title: "text-red-700",
      message: "text-red-600",
      iconBg: "bg-red-100",
      icon: "❌",
    },
    info: {
      border: "border-blue-500",
      title: "text-blue-700",
      message: "text-blue-600",
      iconBg: "bg-blue-100",
      icon: "ℹ️",
    }
  };

  const styles = colorStyles[type] || colorStyles.info;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className={`relative bg-white rounded-lg shadow-lg p-6 max-w-sm w-full border-l-4 ${styles.border}`}>
        
        {/* Close Icon */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 focus:outline-none"
        >
          <X size={20} />
        </button>

        <div className="flex items-start space-x-3 mb-4">
          <div className={`w-8 h-8 flex items-center justify-center rounded-full ${styles.iconBg}`}>
            <span className="text-lg">{styles.icon}</span>
          </div>
          <div>
            <h2 className={`text-lg font-semibold mb-1 ${styles.title}`}>{title}</h2>
            <p className={`text-sm ${styles.message}`}>{message}</p>
            {children && <div className="mt-4">{children}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;